import { Box, Typography } from "@mui/material";

type ProPlaceholderPageProps = {
  title: string;
  description?: string;
};

export default function ProPlaceholderPage({
  title,
  description,
}: ProPlaceholderPageProps) {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      <Typography variant="h6" gutterBottom>
        Coming Soon
      </Typography>
      <Typography>
        {description ||
          "This Pro feature is currently in development. Future functionality will include stock tracking, usage tracking, inventory audits and adjustments, and reporting."}
      </Typography>
    </Box>
  );
}
